import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=0b3f4d14&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"
import style0 from "./Applications.vue?vue&type=style&index=0&id=0b3f4d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f4d14",
  null
  
)

export default component.exports